var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row mh-lg-100-vh align-content-start mb-40" },
    [
      _vm.items.activity.length == 0
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("no-activities-card", { attrs: { "fixed-width": true } })
                ],
                1
              )
            ])
          ])
        : _c("activities-row", {
            attrs: {
              "force-grid": true,
              title: "Mijn teambuildings",
              col: "col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80",
              activities: _vm.items.activity,
              "items-per-row": 3,
              ratio: "250:175"
            },
            on: { updated: _vm.setList }
          }),
      _vm._v(" "),
      _vm.items.speaker.length > 0 ||
      _vm.items.location.length > 0 ||
      _vm.items.staticItem.length > 0 ||
      _vm.items.gift.length > 0
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row extras-row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-8 col-xxl-10 data-fixed-side mb-40 mb-md-80"
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mb-n24" },
                    [
                      _vm._l(_vm.items.speaker, function(speaker) {
                        return _c(
                          "div",
                          {
                            key: speaker.id,
                            staticClass: "col-12 col-sm-6 col-xl-4 mb-24"
                          },
                          [
                            _c("speaker-card", {
                              attrs: { speaker: speaker, ratio: "250:175" },
                              on: { updated: _vm.setList }
                            }),
                            _vm._v(" "),
                            _vm._m(2, true)
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.items.location, function(location) {
                        return _c(
                          "div",
                          {
                            key: location.id,
                            staticClass: "col-12 col-sm-6 col-xl-4 mb-24"
                          },
                          [
                            _c("location-card", {
                              attrs: { location: location, ratio: "250:175" },
                              on: { updated: _vm.setList }
                            }),
                            _vm._v(" "),
                            _vm._m(3, true)
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.items.staticItem, function(staticItem, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-12 col-sm-6 col-xl-4 mb-24"
                          },
                          [
                            _c("static-card", {
                              staticClass: "w-100 h-100",
                              attrs: {
                                staticItem: staticItem,
                                pages: _vm.pages,
                                ratio: "250:175"
                              },
                              on: { updated: _vm.setList }
                            }),
                            _vm._v(" "),
                            _vm._m(4, true)
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.items.gift, function(gift) {
                        return _c(
                          "div",
                          {
                            key: gift.id,
                            staticClass: "col-12 col-sm-6 col-xl-4 mb-24"
                          },
                          [
                            _c("gift-card", {
                              staticClass: "w-100 h-100",
                              attrs: {
                                gift: gift,
                                pages: _vm.pages,
                                ratio: "250:175"
                              },
                              on: { updated: _vm.setList }
                            }),
                            _vm._v(" "),
                            _vm._m(5, true)
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("floating-side-wrapper", { staticClass: "order-list" }, [
        _c("div", { staticClass: "p-56 text-white bg-dark" }, [
          _c("h3", {
            staticClass: "mb-16",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.order.title) }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-16 font-weight-light text-cut",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.order.description) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "btn btn-accent btn-white-hover",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.order.cta) },
            on: { click: _vm.showCreateOrder }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-56" }, [
          _c("h3", {
            staticClass: "mb-16",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.contact.title) }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-16 font-weight-light",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.contact.description) }
          }),
          _vm._v(" "),
          _c("a", {
            staticClass: "btn btn-accent",
            attrs: { href: _vm.copyConfig.contact.cta_link },
            domProps: { innerHTML: _vm._s(_vm.copyConfig.contact.cta) }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("Mijn teambuildings")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("Mijn extra's")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-row mt-12" }, [
      _c("div", { staticClass: "tag-col" }, [
        _c("div", { staticClass: "tag tag-accent-light tag-xs" }, [
          _vm._v("Spreker")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-row mt-12" }, [
      _c("div", { staticClass: "tag-col" }, [
        _c("div", { staticClass: "tag tag-accent-light tag-xs" }, [
          _vm._v("Locatie")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-row mt-12" }, [
      _c("div", { staticClass: "tag-col" }, [
        _c("div", { staticClass: "tag tag-accent-light tag-xs" }, [
          _vm._v("Extra")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-row mt-12" }, [
      _c("div", { staticClass: "tag-col" }, [
        _c("div", { staticClass: "tag tag-accent-light tag-xs" }, [
          _vm._v("Gift")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }